/* eslint-disable max-len */
import axios from 'axios';
import { store } from 'store';
import { ENDPOINTS } from './endpoints';

let API;

if (process.env.NODE_ENV === 'development') {
  API = axios.create({
    baseURL: `http://${process.env.REACT_APP_SERVICES_PLATFORM_ADDRESS}:${process.env.REACT_APP_SERVICES_PLATFORM_PORT}/`,
  });
} else {
  API = axios.create({
    baseURL: `${process.env.REACT_APP_FRONTEND_URL}/platform/`,
  });
}

API.interceptors.request.use(
  (config) => {
    const { isOnline } = store.getState().platform;

    if (!isOnline) {
      return Promise.reject(
        new axios.Cancel('Request blocked: No Internet Connection')
      );
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const addReactionOnBlog = (blogId, reactionValue, token) =>
  API.post(
    ENDPOINTS.add_reaction_on_article(blogId, reactionValue),
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

const addCommentOnBlog = (blogId, payload, token) =>
  API.post(ENDPOINTS.add_commentOnArticle(blogId), payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const initiateTransaction = (payload, token) =>
  API.post(ENDPOINTS.create_order, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const buildPlatformConfig = () => API.get(ENDPOINTS.get_platform_config);

const getBlog = (blogId) => API.get(ENDPOINTS.get_blog(blogId));

const getSubscriptionValidity = (token) =>
  API.get(ENDPOINTS.get_subscription_validity, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const getCommentsforBlog = (page, size, blogId) =>
  API.get(ENDPOINTS.get_comments_for_article(page, size, blogId));

const getTransactions = (token) =>
  API.get(ENDPOINTS.get_transaction_detail, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const platformSearch = (query) => API.get(ENDPOINTS.platform_search(query));

const platformSearchResults = (page, size, query, token) =>
  API.get(ENDPOINTS.platform_search_results(page, size, query), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

const userCampaign = (payload) =>
  API.post(ENDPOINTS.add_user_campaign, payload);

const validatePayment = (payload) => API.post(ENDPOINTS.verifyPayment, payload);

export {
  addCommentOnBlog,
  addReactionOnBlog,
  buildPlatformConfig,
  getBlog,
  getCommentsforBlog,
  getSubscriptionValidity,
  getTransactions,
  initiateTransaction,
  platformSearch,
  platformSearchResults,
  userCampaign,
  validatePayment,
};
